export const getTimestampToIso = (timestamp: number): string => {
  if (!timestamp || !Number.isInteger(timestamp) || timestamp < 0) {
    return ''
  }

  return new Date(timestamp).toISOString()
}
